// extracted by css-extract-rspack-plugin
export default {"tabList":"n7Ff7","scrollButton":"s69GH","left":"TDN9S","right":"aq5iB"};